'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$109() {
  this.bda = null;
  this.bdb = false;
}
export { $c_Lpresto_PrestoRouter$$anon$109 as $c_Lpresto_PrestoRouter$$anon$109 };
$p = $c_Lpresto_PrestoRouter$$anon$109.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$109;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$109() {
}
export { $h_Lpresto_PrestoRouter$$anon$109 as $h_Lpresto_PrestoRouter$$anon$109 };
$h_Lpresto_PrestoRouter$$anon$109.prototype = $p;
$p.P = (function() {
  if ((!this.bdb)) {
    this.bda = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bdb = true;
  }
  return this.bda;
});
var $d_Lpresto_PrestoRouter$$anon$109 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$109, "presto.PrestoRouter$$anon$109", ({
  NG: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$109 as $d_Lpresto_PrestoRouter$$anon$109 };
//# sourceMappingURL=presto.-Presto-Router$$anon$109.js.map
